import { cn } from '@/lib/utils';

type SessionCallLiveCaptionsOverlayProps = {
	lines: string[];
	className?: string;
};

const SessionCallLiveCaptionsOverlay = ({
	lines,
	className,
}: SessionCallLiveCaptionsOverlayProps) => {
	const visibleLines = lines.filter((line) => line.trim().length > 0);

	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-x-0 bottom-[4.5rem] z-20 flex justify-center px-4 md:bottom-[5rem]',
				className,
			)}
			aria-live="polite"
			aria-atomic="true"
			role="status"
		>
			<div
				className={cn(
					'max-w-[min(100%,42rem)] rounded-md px-3 py-2 text-center',
					'bg-black/75 text-[15px] font-medium leading-snug text-white',
					'shadow-lg backdrop-blur-sm',
				)}
			>
				{visibleLines.length > 0 ? (
					visibleLines.map((line, index) => (
						<p key={`${index}-${line.slice(0, 24)}`}>{line}</p>
					))
				) : (
					<p className="text-white/70">
						Aguardando fala para legendar…
					</p>
				)}
			</div>
		</div>
	);
};

export { SessionCallLiveCaptionsOverlay };
